// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2gXt8","row":"Node_row__1eGby","label":"Node_label__3Shp4","footer":"Node_footer__1BAVG"};